export default {
    LOADING_MESSAGES: {
        FETCH: 'Fetching SMTP configuration',
        SAVE: 'Saving SMTP configuration',
        REMOVE: 'Removing SMTP configuration',
        TEST: 'Sending test email to {EMAIL}',
    },
    VIEW_NOTIFICATIONS: {
        SAVED: {kind: 'SUCCESS', text: 'Configuration saved.'},
        TEST_PASSED: {kind: 'SUCCESS', text: 'Test email successfully sent.'},
        NONE: {kind: 'NONE'},
        ERROR: {kind: 'ERROR', text: 'Unfortunately, error occurred. Please review and rectify:', error: ''}
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/smtp/consts.js